<template>
  <div>
    <div class="row top">
      <div class="row">
        <div class="col-md-2">
          <back-button returnUrl="/home"></back-button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <h4><u>Admin tools</u></h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="flex-container">
        <div class="col-md-4">
          <button
            class="invert"
            id="btnApiLogs"
            v-if="isSuperAdmin"
            @click="showApiLogs"
          >
            Api log file
          </button>
        </div>
        <div class="col-md-4">
          <button
            class="invert"
            id="btnApiLogs"
            v-if="isSuperAdmin"
            @click="showLoginLogs"
          >
            Logins log file
          </button>
          <button
            class="invert"
            id="btnEditVerificationsOtpValidUntil"
            v-if="isSuperAdmin"
            @click="editVerificationsOtpValidUntil"
          >
            Ενημέρωση Διάρκειας OTP
          </button>
        </div>
        <div class="col-md-4">
          <button
            class="invert"
            id="btnVersions"
            v-if="isSuperAdmin"
            @click="showVersions"
          >
            Versions
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../../router";
import BackButton from "../../components/shared/backButton";

export default {
  components: {
    BackButton,
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    isSuperAdmin() {
      return this.$store.getters.isSuperAdmin;
    },
  },
  methods: {
    showApiLogs() {
      router.replace("/apiLogging");
    },
    showLoginLogs() {
      router.replace("/userLogging");
    },
    showVersions() {
      router.replace("/versions");
    },
    editVerificationsOtpValidUntil() {
      router.replace("/verificationsOtpValidUntil");
    },
  },
};
</script>
